// extracted by mini-css-extract-plugin
export default {"button-link":"jgPyIW9rOx2Gceuu6bqX"};